import * as Constants from '../constants/';

const initialState = {
  isSaving: null,
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_UPLOAD_PROFILE:
      return { ...state, isSaving: true };
    case Constants.RECEIVE_UPLOAD_PROFILE:
      if (action.error) {
        return { ...state, isSaving: false, error: action.error };
      }
      return {
        ...state,
        isSaving: false,
        error: null
      };
    default:
      return state;
  }
}
